<template>
	<div class="dynamic_content">
		<p>
			<i class="el-icon-s-home"></i>
			<span>网站首页</span>/ 新闻动态/ {{typeName}}
		</p>
		<div class="content" v-html="content.renote"></div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				content: '',
				typeName: '',
			};
		},
		mounted() {
			var data = JSON.parse(sessionStorage.getItem('dynamic_content'));
			if(data.type == 1) {
				this.typeName = '本会动态'
			} else if(data.type == 2) {
				this.typeName = '行业动态'
			} else if(data.type == 3) {
				this.typeName = '通知公告'
			} else {
				this.typeName = '政策法规'
			}
			this.content = data;
			
		},
		methods: {},
	};
</script>
<style scoped>
	.dynamic_content>p {
		width: 100%;
		border-bottom: 1px solid #ddd;
		padding-bottom: 10px;
		color: gray;
	}

	.dynamic_content>p i {
		margin-right: 10px;
	}

	.dynamic_content>p span:hover {
		color: #016fb8;
		cursor: pointer;
	}
	.dynamic_content .content {
		line-height: 30px;
		padding: 20px 30px;
		box-sizing: border-box;
		color: gray;
		font-size: 13px;
	}
</style>
